import {Button, Container, Row, Spinner, Card, Alert} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus, faFilter, faSync} from "@fortawesome/free-solid-svg-icons";
import Col from "react-bootstrap/Col";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import AddOrEditFilterModal from "./AddOrEditFilterModal";
import StatusReportFiltersTable from "./statusReportFiltersTable";
import statusReportFilterService from "../services/statusReportFilterService";
import _ from "lodash";


function ReportsSettings() {
    const [filters, setFilters] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAddFilterModal, setShowAddFilterModal] = useState(false);
    const [editingFilter, setEditingFilter] = useState(null);
    const [sortColumn, setSortColumn] = useState({ path: "updatedAt", order: "desc" });

    useEffect(() => {
        loadFilters();
    }, []);

    const loadFilters = async () => {
        try {
            setLoading(true);
            const response = await statusReportFilterService.getAll();
            setFilters(response.data || []);
        } catch (error) {
            console.error("Błąd podczas ładowania filtrów:", error);
            toast.error("Nie udało się załadować filtrów");
        } finally {
            setLoading(false);
        }
    };

    const handleAddFilter = () => {
        setEditingFilter(null);
        setShowAddFilterModal(true);
    };

    const handleEditFilter = (filter) => {
        setEditingFilter(filter);
        setShowAddFilterModal(true);
    };

    const handleDeleteFilter = async (filter) => {
        try {
            await statusReportFilterService.remove(filter._id);
            toast.success("Filtr został usunięty");
            loadFilters();
        } catch (error) {
            console.error("Błąd podczas usuwania filtru:", error);
            toast.error("Nie udało się usunąć filtru");
        }
    };

    const handleFilterModalClose = () => {
        setShowAddFilterModal(false);
        setEditingFilter(null);
    };

    const handleFilterChange = () => {
        loadFilters();
    };

    const handleSort = (sortColumn) => {
        setSortColumn(sortColumn);
    };

    const getSortedFilters = () => {
        return _.orderBy(filters, [sortColumn.path], [sortColumn.order]);
    };


    return (
        <React.Fragment>
            <Breadcrumb style={{backgroundColor: "#DDDDDD"}}>
                <Breadcrumb.Item style={{marginTop: 3, marginLeft: 3, marginBottom: 3, marginRight: 0}} href="/">Home</Breadcrumb.Item>
                <Breadcrumb.Item style={{marginTop: 3, marginLeft: 3, marginBottom: 3, marginRight: 0}} active>Raportowanie</Breadcrumb.Item>
                <Breadcrumb.Item style={{marginTop: 3, marginLeft: 3, marginBottom: 3, marginRight: 0}} active>Ustawienia raportów</Breadcrumb.Item>
            </Breadcrumb>
            <div className="App">
                <div>
                    <ToastContainer/>
                </div>
                <Container fluid>
                    <Row className="mb-4">
                        <Col md={12}>
                            <div className="d-flex justify-content-between align-items-center">
                                <h4>
                                    <FontAwesomeIcon icon={faFilter} className="me-2" />
                                    Filtry raportów statusu
                                </h4>
                                <div>
                                    <Button 
                                        variant="outline-secondary" 
                                        className="me-2"
                                        onClick={loadFilters}
                                        disabled={loading}
                                    >
                                        <FontAwesomeIcon icon={faSync} className="me-1" />
                                        Odśwież
                                    </Button>
                                    <Button 
                                        variant="primary" 
                                        onClick={handleAddFilter}
                                        disabled={loading}
                                    >
                                        <FontAwesomeIcon icon={faPlus} className="me-1" />
                                        Dodaj filtr
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <Card>
                                <Card.Header>
                                    <h6 className="mb-0">
                                        Lista filtrów ({filters.length})
                                    </h6>
                                </Card.Header>
                                <Card.Body>
                                    {loading ? (
                                        <div className="text-center py-4">
                                            <Spinner animation="border" />
                                            <div className="mt-2">Ładowanie filtrów...</div>
                                        </div>
                                    ) : filters.length === 0 ? (
                                        <Alert variant="info" className="mb-0">
                                            <strong>Brak filtrów</strong>
                                            <br />
                                            Nie masz jeszcze żadnych filtrów raportów statusu. 
                                            Kliknij przycisk "Dodaj filtr", aby utworzyć pierwszy filtr.
                                        </Alert>
                                    ) : (
                                        <StatusReportFiltersTable
                                            filters={getSortedFilters()}
                                            onEdit={handleEditFilter}
                                            onDelete={handleDeleteFilter}
                                            onSort={handleSort}
                                            sortColumn={sortColumn}
                                        />
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                {/* Modal do dodawania/edycji filtrów */}
                <AddOrEditFilterModal
                    show={showAddFilterModal}
                    onHide={handleFilterModalClose}
                    filter={editingFilter}
                    onFilterChange={handleFilterChange}
                />
            </div>
        </React.Fragment>
    );
}

export default ReportsSettings;
